// extracted by mini-css-extract-plugin
module.exports = {"info":"GuidePersonalInfo_info__39pHo","rating":"GuidePersonalInfo_rating__2OKJT","data":"GuidePersonalInfo_data__uCOWC"};